module.exports = __webpack_public_path__ + "assets/img/jiahao_fill.8f44dc41.svg";